import { ReactElement } from 'react';

export const showIf = (check: any, show: () => ReactElement): ReactElement|null => {
    if (check) {
        return show();
    }

    return null;
};

export const rad2deg = (rad: number) => rad * 180 / Math.PI;

export const deg2rad = (deg: number) => deg * Math.PI / 180;

export const arrayEqual = (arr1: any[], arr2: any[]): boolean => {
    if (!arr1 || !arr2) {
        console.warn('arrayEqual(): One of the supplied arrays is falsey.');
        return false;
    }

    // If they're equal we can short circuit
    if (arr1 === arr2) return true;

    // If the lengths are different we can short circuit
    if (arr1.length !== arr2.length) return false;

    // Loop through every item in array 2
    for (let i = 0; i < arr2.length; i++) {
        // If the first array doesn't contain the current
        // item, the arrays are not equal.
        if (!arr1.includes(arr2[i])) {
            return false;
        }
    }

    // We got this far - the arrays must be the same!
    return true;
};

export const entries = Object.entries as <T>(o: T) => [Extract<keyof T, string>, T[keyof T]][];
